<template>
    <div id="addCommentModal">
        <div class="modal fade" :class="{'in': isVisible, 'open': isVisible}" role="dialog"
             aria-labelledby="addCommentModal" tabindex="-1">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="modal-header">
                            <h1 class="modal-title text-center">
                              <span>
                                <img src="https://polylith-public-files.s3.eu-central-1.amazonaws.com/007++Rated+message-Yellow.png"
                                         class="icon"/>
                              </span>
                              Code kommentieren
                            </h1>
                        </div>
                        <form v-on:submit.prevent="save">
                            <div class="row">
                                <div class="col-xs-12 col-sm-10 col-sm-offset-1">
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <p>Bewerte und kommentiere den Code aber bitte seid nett zueinander <i
                                                    class="dev-heart" style="margin-left:0.2rem;"></i></p>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 1rem; margin-bottom:1rem;">
                                        <div class="col-xs-12">
                                            <label>Dein ausgewählter Code:</label>
                                            <pre v-html="selectedCode"></pre>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-xs-12">
                                            <label>Wähle ein passendes Emoji*:</label>
                                            <div class="row">
                                                <div class="col-xs-12" v-if="hasErrorMessageForField('judgement')">
                                                    <div
                                                         class="alert alert-danger alert-dismissible"
                                                         role="alert">
                                                        <p v-for="message of getErrorMessageForField('judgement')">
                                                            {{message}}</p>
                                                    </div>
                                                </div>
                                                <div v-for="[value, option] in judgementOptions">
                                                    <div class="col-xs-3 col-sm-1">
                                                        <img class="icon judgement-icon"
                                                             v-bind:class="{'selected': judgement === value}"
                                                             :src="option.imageUrl"
                                                             @click="setJudgement(value)"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-xs-12">
                                            <label for="codeComment">Schreibe deine Meinung zu dieser
                                                Codezeile*:</label>
                                            <div v-if="hasErrorMessageForField('comment')"
                                                 class="alert alert-danger alert-dismissible"
                                                 role="alert">
                                                <p v-for="message of getErrorMessageForField('comment')">
                                                    {{message}}</p>
                                            </div>
                                            <textarea ref="commentTextArea"
                                                      class="form-control comment-input" id="codeComment"
                                                      v-model="comment"
                                                      placeholder="Ich liebe diese Codezeile, weil..."
                                                      :maxlength="maxCommentLength">
                                            </textarea>
                                            <text-length-indicator :text="comment" :max-text-length="maxCommentLength"/>
                                        </div>
                                    </div>
                                    <p class="small">* Pflichtfelder</p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-secondary" @click="close()">Abbrechen</button>
                                <button @click="sendCommentPost()" class="btn btn-primary" type="submit">
                                    <i class="dev-save"></i>
                                    <span class="loading-spinner" v-if="!commentPostResponse.loaded"></span>
                                    Speichern
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div @click="close()" class="modal-backdrop fade in" v-if="isVisible"></div>
        </div>

    </div>
</template>

<script>
    import {eventBus, services} from "../../main";
    import {CODE_COMMENT_JUDGEMENT_CHOICES} from "../../const";
    import TextLengthIndicator from "../TextLengthIndicator";

    export default {
        name: "AddCommentModal",
      components: {TextLengthIndicator},
      props: {
            isVisible: {type: [Boolean], default: false},
        },
        data() {
            return {
                commentPostResponse: {loaded: true, error: null},
                comment: "",
                range: {
                    startLineNumber: null,
                    startColumn: null,
                    endLineNumber: null,
                    endColumn: null,
                },
                judgementOptions: CODE_COMMENT_JUDGEMENT_CHOICES,
                selectedCode: "",
                solutionId: null,
                judgement: null,
                maxCommentLength: 500,
            }
        },
        methods: {
            save() {
            },
            close() {
                this.$emit('close');
                this.resetData();
            },
            sendCommentPost() {
                this.commentPostResponse = services.rankTheCodeService.postCodeComment(this.solutionId, this.range, this.judgement, this.comment);
            },
            setRange(range) {
                this.range = range;
            },
            setSolutionId(solutionId) {
                this.solutionId = solutionId;
            },
            setJudgement(judgement) {
                if (judgement === this.judgement) {
                    this.judgement = null;
                    return;
                }
                this.judgement = judgement;
            },
            setCode(code) {
                this.selectedCode = code;
            },
            resetData() {
                this.comment = "";
                this.judgement = 0;
                this.selectedCode = "";
                this.range = {
                    startLineNumber: null,
                    startColumn: null,
                    endLineNumber: null,
                    endColumn: null,
                };
                this.commentPostResponse = {loaded: true, error: null};
            },
            hasErrorMessageForField(field) {
                return this.commentPostResponse.error && this.commentPostResponse.error.additionalData && this.commentPostResponse.error.additionalData.fields[field]
            },
            getErrorMessageForField(field) {
                return this.commentPostResponse.error.additionalData.fields[field]
            },
        },
        watch: {
            "isVisible": function () {
                if (this.isVisible) {
                    this.$nextTick(function () {
                        this.$refs.commentTextArea.focus();
                    })
                }
            },
            "commentPostResponse.loaded": function () {
                if (this.commentPostResponse.loaded && !this.commentPostResponse.error) {
                    if (this.commentPostResponse.apiData) {
                      eventBus.$emit("rank-the-code-comments-updated", {
                        "solutionId": this.commentPostResponse.apiData.solutionId,
                        "commentCount": this.commentPostResponse.apiData.commentCount
                      });
                    }
                    this.close();
                }
            }
        },
    }
</script>

<style scoped>
    .modal-backdrop {
      height: 100vh;
      width: 200vw;
      top: -4rem;
      left: -100vw;
    }

    .col-centered {
        float: none;
        margin: 0 auto;
    }

    .errorLabel {
        color: #a94442;
    }

    .errorBorder {
        border-color: #a94442;
    }

    .open {
        display: block;
    }

    .modal.open {
        z-index: 2200;
    }

    .modal-content {
        padding-top: 1.5rem;
    }

    .modal-dialog {
        width: 1000px;
        margin-top: 12rem;
        z-index: 2300;
    }

    .modal-header {
        margin-bottom: 3.5rem;
    }

    .modal-title {
        margin-bottom: 1.5rem;
    }

    .modal-title img {
        height: 35px;
        margin-right: 1rem;
        margin-top: -5px;
    }

    .judgement-icon {
        opacity: 0.4;
        transition: opacity .25s ease-out;
        margin-bottom: 1.5rem;
    }

    .judgement-icon:hover {
        cursor: pointer;
        opacity: 1;
        transition: opacity .25s ease-out;
    }

    .selected {
        opacity: 1.0;
    }

    .icon {
      height: 5rem;
    }

    .comment-input {
      border: none;
      display: flex;
      padding: 2rem 2rem;
      background-color: #F4F8FB !important;
      border-radius: 10px;
      align-items: flex-end;
      overflow-x: hidden;
    }

    @media (max-width: 1000px) {
      .modal-dialog {
        width: 100%;
        margin-left: 0;
      }
    }




</style>
